import axios from "axios";
const baseURL = process.env.REACT_APP_API_URL;

// Create New URL
export const create_url = async (values: any) => {
    // Backend expects project_category_ids for categories array
    const response = await axios.post(baseURL + "/urls", values);
    return response.data;
}

// List URLs of a Project
export const get_urls_of_project = async (projectId: string) => {
    const response = await axios.get(baseURL + `/project-urls/${projectId}`, {
        params: { _t: Date.now() }
    });
    return response.data;
}

// Get Single URL
export const get_single_url = async (id: string) => {
    const response = await axios.get(baseURL + `/urls/${id}`);
    return response.data;
}

// Update URL
export const update_url = async (id: string, values: any) => {
    const response = await axios.put(baseURL + `/urls/${id}`, values);
    return response.data;
}

// Delete URL
export const delete_url = async (id: string) => {
    const response = await axios.delete(baseURL + `/urls/${id}`);
    return response.data;
}

// Get All Project URLs Logs
export const get_all_project_urls_logs = async (projectId: number) => {
    let response = await axios.get(baseURL + `/all-url-logs/${projectId}`);
    return response.data;
}

// Get Single Project URL Log
export const get_single_project_url_log = async (urlId: number) => {
    let response = await axios.get(baseURL + `/single-url-log/${urlId}`);
    return response.data;
}

